module.exports = __webpack_public_path__ + "img/BE.59ca6fd0.svg";